import { render } from "./follow_request_card.vue?vue&type=template&id=072f0bb6"
import script from "./follow_request_card.js?vue&type=script&lang=js"
export * from "./follow_request_card.js?vue&type=script&lang=js"

import "./follow_request_card.vue?vue&type=style&index=0&id=072f0bb6&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__